import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { ConfirmationOverlayService } from './confirmation-overlay.service';
import { map, tap } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'm-confirmation-overlay',
  templateUrl: './confirmation-overlay.component.html',
  styleUrls: ['./confirmation-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class ConfirmationOverlayComponent {
  private confirmationOverlayService = inject(ConfirmationOverlayService);

  message = this.confirmationOverlayService.events.pipe(
    tap(event => {
      this.hidden = !event.visible;
    }),
    map(event => event.message)
  );

  @HostBinding('class.hidden') hidden = true;
}
